import LegalPage from './LegalPage';
import termsOfUse from '../data/termsOfUse';

export default function TermsOfUse() {
  return <LegalPage document={termsOfUse} />;
}